import { RequiredDeep } from 'vtils/types'

export function requiredDeep<T>(x: T): RequiredDeep<T> {
  return x as any
}
